import { useCallback, useContext } from 'react';

import { createSearchClient } from '@/integrations/algolia/searchClientBuilder';
import type { ContactHit } from '@/integrations/algolia/types';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

export const useNativeCall = (countryCode: string) => {
  const draftMode = useContext(DraftModeContext);

  const initiateNativeCall = useCallback(async () => {
    const algoliaSearchClient = createSearchClient({
      isPreview: draftMode,
    });
    const index = algoliaSearchClient.initIndex(
      `${process.env.NEXT_PUBLIC_ENVIRONMENT_NAME}.CONTACT_CENTER`,
    );
    try {
      const { hits } = await index.search<Partial<ContactHit>>('', {
        filters: `country_code:${countryCode}`,
        attributesToRetrieve: ['phone_number'],
      });
      const phoneNumber =
        hits && hits.length && hits[0].phone_number
          ? hits[0].phone_number
          : '+41 32 654 54 54';
      window.location.href = `tel:${phoneNumber}`;
    } catch (error) {
      console.error('Error fetching contact data:', error);
      window.location.href = 'tel:+41 32 654 54 54';
    }
  }, [countryCode]);

  return { initiateNativeCall };
};
